import { render, staticRenderFns } from "./BrandLc.vue?vue&type=template&id=387a50af&scoped=true&"
import script from "./BrandLc.vue?vue&type=script&lang=js&"
export * from "./BrandLc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387a50af",
  null
  
)

export default component.exports